<template>
    <div class="project">
        <div class="project-content">
            <form>
                <div class="projectInfo">
                    <div>
                        <InputField label="项目名称" type="text" id="project"
                                    label-width="40%" :disabled="isDetails"
                                    :modelValue="form.projectName" placeholder="请输入项目名称"
                            @update:modelValue="(value) => handleModelValueUpdate('projectName', value)"
                        />
                    </div>
                    <div>
                        <DatePickerField labelWidth="40%" label="检测日期" :disabled="isDetails"
                                         name="testDate" placeholder="请选择检测日期"
                                         :modelValue="form.testDate" id="testDate"
                                         @update:modelValue="(value) => handleModelValueUpdate('testDate', value)"
                        />
                    </div>
                </div>
                <div class="projectInfo">
                    <div>
                        <InputField label="管网数量" type="text" id="totalQuantity"
                                    label-width="40%" :disabled="isDetails"
                                    :modelValue="form.totalQuantity" placeholder="请输入管网数量"
                                    @update:modelValue="(value) => handleModelValueUpdate('totalQuantity', value)"
                        />
                    </div>
                    <div>
                        <InputField label="管网长度" type="text" id="totalLength"
                                    label-width="40%" :disabled="isDetails"
                                    :modelValue="form.totalLength" placeholder="请输入管网长度"
                                    @update:modelValue="(value) => handleModelValueUpdate('totalLength', value)"
                        />
                    </div>
                </div>
                <div class="projectInfo1">
                    <div>
                        <TextareaField :modelValue="form.remark"  label="备注" labelWidth="15%"
                                       placeholder="请输入备注" :disabled="isDetails" id="remark"
                                       @update:modelValue="(value) => handleModelValueUpdate('remark', value)"
                                      />

                    </div>
                </div>
                <div>
                    <div style="display: flex;">
                        <label class="form-label" style="width:15%;display: block;color: #94a3b8;font-size: 0.9rem;margin-right: 0.5rem;">
                            <span style="visibility: hidden;">*</span>
                            上传附件
                        </label>
                        <div class="image-grid">
                            <div v-for="(item,index) in fileList" :key="item.id" class="image-item">
                                <div class="attachment-container">
                                    <span style="display: inline-block;width: 90%;">{{item.completePath}}</span>
                                    <span style="color: #ff5900;margin-left: 1rem;cursor: pointer;" @click="deleteAttachment(index)"> X</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </form>
            <div class="project-button">
                <a-space>
                    <ButtonField text="关闭" @click="cancel" secondary />
                    <ButtonField v-if="!isDetails" text="保存" primary @click="handleSubmit"/>
                    <Upload :list="fileList" @change="onUpload" :title="'上传pdf'"/>
                </a-space>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "project",
    props:{
        isDetails:{
            type:Boolean,
            default:false
        },
        projectInfo:{
            type:Object,
            default:()=>{
                return {}
            }
        }
    },
    data() {
        return {
            fileList:[],
            form:{
                projectName: '',
                testDate: '',
                totalQuantity: '',
                totalLength: '',
                remark: ''
            }
        }
    },
    mounted() {
        if (this.projectInfo) {
            this.form = {
                ...this.projectInfo,
                testDate: this.projectInfo.testDate
                    ? (this.projectInfo.testDate instanceof Date
                        ? this.formatDate(this.projectInfo.testDate)
                        : this.projectInfo.testDate)
                    : ''
            }
            const { attachment } = this.form;
            if (attachment) {
                this.fileList = Array.isArray(attachment)
                    ? attachment.map((url, index) => ({
                        url,
                        completePath: url,
                        name: index,
                        id: Date.now() + Math.random()
                    }))
                    : String(attachment).split(';')
                        .filter(url => url.trim())
                        .map((url, index) => ({
                            url,
                            completePath: url,
                            name: index,
                            id: Date.now() + Math.random()
                        }));
            }

        }
    },
    methods:{
        onUpload(val) {
            this.fileList = val || [];
        },
        deleteAttachment(index){
            this.fileList = this.fileList.filter((_, i) => i !== index);
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        cancel(){
            this.$emit( 'cancel',false)
        },
        handleSubmit(){
            this.form.attachment = this.fileList.map(file => file.completePath).join(';');
            console.log("handleSubmit:::",this.form)
            if(this.form.id){
                this.$emit('update', this.form);
            }else{
                this.$emit('save', this.form);
            }
            this.$emit( 'cancel',false)
        }
    }
}
</script>

<style scoped>
.project{
    color: #fff;
}
.projectInfo{
    display: flex;
    justify-content: space-between;
}
.projectInfo1{
    margin: 0.5rem 0;
}
.projectInfo > div{
    width: 48%;
    margin: 0.5rem 0;
}
.project-button{
    display: flex;
    justify-content: center;
    margin: 1rem 0 0 0;
}
.attachment-container{
    margin: 1rem 0;
}
</style>